import styles from '@/styles/buying-guide/popular-buying-guides.module.scss'
import GuidesItem from '@/components/buying-guide/GuidesItem'
import SwiperSelf from '@/components/SwiperSelf'
import { SwiperSlide } from 'swiper/react';

interface PopularBuyingGuidesItem {
  categoryID?: number;
  name: string;
  guideUrl: string;
  imgUrl: string;
  seoDescription: string | null;
}

interface PopularBuyingGuidesProps {
  type?: string;
  PopularBuyingGuidesData: PopularBuyingGuidesItem[][];
}

export default function PopularBuyingGuides(props: PopularBuyingGuidesProps) {
  return (
    <>
      <div className={styles['comp-popular-buying-guides']}>
        {
          !!(props?.PopularBuyingGuidesData && props.PopularBuyingGuidesData.length) &&
          <SwiperSelf
            slidesPerView={1}
            pagination={false}
            loop={false} 
            autoplay={true} 
            delay={6000}
          >
            {
              props.PopularBuyingGuidesData?.map((item: PopularBuyingGuidesItem[], index:number) => (
                <SwiperSlide key={index}>
                  <div className={styles['guides-list']}>
                    {
                      item?.map((product: PopularBuyingGuidesItem, index:number) => (
                        <div className={styles['guides-item']} key={index}>
                          <GuidesItem PopularBuyingGuidesData={product}></GuidesItem>
                        </div>
                      ))
                    }
                  </div>
                </SwiperSlide>
              ))
            }
          </SwiperSelf>
        }
      </div>
    </>
  )
}